import React from 'react';

interface MomentumRingProps {
  done: number;
  total: number;
  size?: number;
}

export const MomentumRing = React.memo(function MomentumRing({ done, total, size = 46 }: MomentumRingProps) {
  const strokeWidth = 3.5;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = total > 0 ? done / total : 0;
  const isComplete = progress >= 1;

  return (
    <svg width={size} height={size} className="-rotate-90 shrink-0">
      <circle
        cx={size / 2} cy={size / 2} r={radius}
        fill="none" stroke="#1a1f3a" strokeWidth={strokeWidth}
      />
      <circle
        cx={size / 2} cy={size / 2} r={radius}
        fill="none"
        stroke={isComplete ? '#55EFC4' : '#6C5CE7'}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeDasharray={circumference}
        strokeDashoffset={circumference * (1 - progress)}
        className="transition-[stroke-dashoffset] duration-800 ease-out"
      />
    </svg>
  );
});
